import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import DrawingBoard from './features/drawingBoard/DrawingBoard';
import InputSlider from './features/drawingBoard/inputSlider';
import Graphic from './features/graphic/Graphic';
import { 
  setPower,
  setKSpringOne,
  setPresetSpringOne,
  setKSpringTwo,
  setPositionSpringTwo,
  setDisplacement,
  setSetting1Offset,
  setSetting2Offset,
  setOverride,
  toggleIdealCurve,
  toggleSpringCurve,
  toggleDoubleSpring,
  selectPower,
  selectKSpringOne,
  selectPresetSpringOne,
  selectKSpringTwo,
  selectPositionSpringTwo,
  selectOverride,
  selectShowIdealCurve,
  selectShowSpringCurve,
  selectDoubleSpring,
  selectDisplacement,
  selectSetting1Offset,
  selectSetting2Offset,
} from './features/drawingBoard/drawingBoardSlice';
import styles from './App.module.css';

function App() {
  const power = useSelector(selectPower);
  const kSpringOne = useSelector(selectKSpringOne);
  const presetSpringOne = useSelector(selectPresetSpringOne);
  const kSpringTwo = useSelector(selectKSpringTwo);
  const positionSpringTwo = useSelector(selectPositionSpringTwo);
  const showIdealCurve = useSelector(selectShowIdealCurve);
  const showSpringCurve = useSelector(selectShowSpringCurve);
  const doubleSpring = useSelector(selectDoubleSpring);
  const displacement = useSelector(selectDisplacement);
  const setting1Offset = useSelector(selectSetting1Offset);
  const setting2Offset = useSelector(selectSetting2Offset);
  const override = useSelector(selectOverride);
  const dispatch = useDispatch();
  const handlePowerChange = (e) => {
    dispatch(setPower(+e.target.value));
  };
  const handleKSpringOneChange = (e) => {
    dispatch(setKSpringOne(+e.target.value));
  };
  const handlePresetSpringOneChange = (e) => {
    dispatch(setPresetSpringOne(+e.target.value));
  };
  const handleKSpringTwoChange = (e) => {
    dispatch(setKSpringTwo(+e.target.value));
  };
  const handlePositionSpringTwoChange = (e) => {
    dispatch(setPositionSpringTwo(+e.target.value));
  };
  const handleOverrideChange = (e) => {
    dispatch(setOverride(+e.target.value));
  };
  const handleToggleIdealCurve = () => {
    dispatch(toggleIdealCurve());
  };
  const handleToggleSpringCurve = () => {
    dispatch(toggleSpringCurve());
  };
  const handleToggleDoubleSpring = () => {
    dispatch(toggleDoubleSpring());
  };
  const handleDisplacementChange = (e) => {
    dispatch(setDisplacement(+e.target.value));
  };
  const handleSetting1OffsetChange = (e) => {
    const val = +e.target.value;
    dispatch(setSetting1Offset(val));
    if ((val+setting2Offset)>110){
      dispatch(setSetting2Offset(110-(val)));
    }
  };
  const handleSetting2OffsetChange = (e) => {
    const val = +e.target.value;
    dispatch(setSetting2Offset(val));
    if ((val+setting1Offset)>110){
      dispatch(setSetting1Offset(110-(val)));
    }
  };
  const reset9kW = () => {
    resetSprings(9,35);
    dispatch(setPower(10));
  };
  const reset15kW = () => {
    resetSprings(37,17);
    dispatch(setPower(15));
  };
  const reset21kW = () => {
    resetSprings(64,0);
    dispatch(setPower(21));
  };
  const resetSprings = (extr,intr) => {
    dispatch(setKSpringOne(1.6));
    dispatch(setKSpringTwo(2.4));
    dispatch(setPresetSpringOne(27));
    dispatch(setSetting1Offset(extr));
    dispatch(setSetting2Offset(intr));
    dispatch(setOverride(0));
  };
  return (
    <div>
      <DrawingBoard
        width="90%"
        height={500}
      >
        <Graphic />
      </DrawingBoard>
      <div>
        <InputSlider 
            label="Displacement"
            display={displacement}
            max={100}
            min={10}
            step={1}
            value={displacement}
            onChange={handleDisplacementChange}
        />
        <div className={styles.buttonsContainer}>
          <div className={styles.sliderLabel}>Ideal Curve</div>
          <button 
            className={styles.optionsButton}
            onClick={handleToggleIdealCurve}
          >
            {showIdealCurve? "Hide" : "Show"}
          </button>
        </div>
        {showIdealCurve ? 
          <InputSlider 
            label="kW"
            display={power}
            max={30}
            min={1}
            step={0.1}
            onChange={handlePowerChange}
            value={power}
          />
        : null}
        <div className={styles.buttonsContainer}>
          <div className={styles.sliderLabel}>Real Curve</div>
          <button 
            className={styles.optionsButton}
            onClick={handleToggleSpringCurve}
          >{showSpringCurve ? "Hide" : "Show"}</button>
          <button 
            className={styles.optionsButton}
            onClick={reset21kW}
          >21kW</button>
          <button 
            className={styles.optionsButton}
            onClick={reset15kW}
          >15kW</button>
          <button 
            className={styles.optionsButton}
            onClick={reset9kW}
          >9kW</button>
          {/*<button 
            className={styles.optionsButton}
            onClick={handleToggleDoubleSpring}
          >{doubleSpring ? "Show Single Spring" : "Show Double Spring"}</button>*/}
        </div>
        {showSpringCurve ? 
          <div>
            <InputSlider 
                label="External Adjustment"
                display={setting1Offset}
                max={100}
                min={0}
                step={1}
                value={setting1Offset}
                onChange={handleSetting1OffsetChange}
            />
            <InputSlider 
                label="Internal Adjustment"
                display={setting2Offset}
                max={100}
                min={0}
                step={1}
                value={setting2Offset}
                onChange={handleSetting2OffsetChange}
            />
            <InputSlider 
              label="Spring1 Constant"
              display={kSpringOne}
              max={10}
              min={0.1}
              step={0.1}
              onChange={handleKSpringOneChange}
              value={kSpringOne}
            />
            <InputSlider 
              label="Spring2 Constant"
              display={kSpringTwo}
              max={10}
              min={0.1}
              step={0.1}
              onChange={handleKSpringTwoChange}
              value={kSpringTwo}
            />
            <InputSlider 
              label="Spring1 preset"
              display={presetSpringOne}
              max={150}
              min={0}
              step={1}
              onChange={handlePresetSpringOneChange}
              value={presetSpringOne}
            />
            <InputSlider 
              label="Override pressure"
              display={override}
              max={300}
              min={0}
              step={1}
              onChange={handleOverrideChange}
              value={override}
            />
          </div>
        :null}
      </div>
    </div>
  );
}

export default App;
